import { render, staticRenderFns } from "./sectionItemForth.vue?vue&type=template&id=231f9a59&scoped=true"
import script from "./sectionItemForth.vue?vue&type=script&lang=ts"
export * from "./sectionItemForth.vue?vue&type=script&lang=ts"
import style0 from "./sectionItemForth.vue?vue&type=style&index=0&id=231f9a59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f9a59",
  null
  
)

export default component.exports